'use client'

import { createContext, useState } from 'react'
import { type Descendant } from 'slate'

export const EditorContentContext = createContext<
  [Descendant[] | null, (content: Descendant[]) => void]
>([null, () => undefined])

export function EditorContentProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const value = useState<Descendant[] | null>(null)

  return (
    <EditorContentContext.Provider value={value}>
      {children}
    </EditorContentContext.Provider>
  )
}
